import { BreakpointWidth } from '@app/enumerations';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		tableDragNDropBody_rowHelper: {
			display: 'table !important',
			tableLayout: 'fixed !important' as any,
		},
	});
});

export default useStyles;
